/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MdClose } from 'react-icons/md';
import { SearchPublishedContent } from '@blaze-cms/nextjs-tools';
import { Link } from '@blaze-cms/nextjs-components';
import HeaderSearchLink from './HeaderSearchLink';

const HeaderSearch = ({
  handleSearchTerm,
  setIsSearchBarOpen,
  isSearchBarOpen,
  currentSearchTerm,
  closeSearchBar,
  router,
  entities,
  searchFields,
  searchUrl,
  closeMenu
}) => {
  const inputRef = useRef(null);
  const handleRoute = ({ pathname, query }) => {
    router.push({
      pathname,
      query
    });
  };

  const parsedResultKeys = searchFields.reduce(
    (acc, value) => `${acc}... on ${value} {
      id,
      name,
      url,
      image {
        url
      }
    }
    `,
    ''
  );

  const handleOnClick = () => {
    closeSearchBar();
    closeMenu && closeMenu();
  };

  return (
    <SearchPublishedContent
      entities={entities}
      onEnterPress={() =>
        handleRoute({
          pathname: `${searchUrl}`,
          query: {
            search_term: currentSearchTerm
          }
        })
      }
      resultKeys={parsedResultKeys}
      placeholder="Search"
      onChange={handleSearchTerm}
      SearchIcon={() => null}
      CloseIcon={() => (
        <i>
          <MdClose />
        </i>
      )}
      getIsOpenSearchBar={state => setIsSearchBarOpen(state)}
      isSearchBarOpen={isSearchBarOpen}
      fields={['name']}
      inputRef={isSearchBarOpen ? inputRef : null}>
      {({ results }) => {
        const shouldDisplayResults = !!results.length && isSearchBarOpen;
        const divClass = classnames({
          'search-modal__content-show': shouldDisplayResults,
          'search-modal__content': !shouldDisplayResults
        });
        return (
          <div className={divClass}>
            {shouldDisplayResults && (
              <>
                {results.map(({ name, url, image }) => (
                  <Link key={name} href={url} onClick={handleOnClick}>
                    <div className="search-modal-result">
                      {image &&
                        image.url && (
                          <img src={image.url} alt="miniature" className="search-modal-miniature" />
                        )}
                      <p>{name}</p>
                    </div>
                  </Link>
                ))}
                <div className="search-modal-result">
                  <HeaderSearchLink
                    currentSearchTerm={currentSearchTerm}
                    handleRoute={handleRoute}
                  />
                </div>
              </>
            )}
            {!results.length &&
              currentSearchTerm && (
                <HeaderSearchLink currentSearchTerm={currentSearchTerm} handleRoute={handleRoute} />
              )}
          </div>
        );
      }}
    </SearchPublishedContent>
  );
};

HeaderSearch.propTypes = {
  handleSearchTerm: PropTypes.func.isRequired,
  setIsSearchBarOpen: PropTypes.func.isRequired,
  isSearchBarOpen: PropTypes.bool.isRequired,
  currentSearchTerm: PropTypes.string.isRequired,
  closeSearchBar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  entities: PropTypes.array,
  searchFields: PropTypes.array,
  searchUrl: PropTypes.string,
  closeMenu: PropTypes.func
};

HeaderSearch.defaultProps = {
  entities: ['published_article'],
  searchFields: ['PublishedArticle'],
  searchUrl: '/search',
  closeMenu: () => ({})
};

export default HeaderSearch;
